import { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { ADD_CHALLAN_FAIL, ADD_CHALLAN_START } from "../../RTK/Slices/ChallanSlice";
import {
    add_budget_reappropriate,
    add_budget_reappropriate_subhead,
    get_schemes,
    get_single_budget_reappropriate, getActivity, getSubActivity, get_departments,
    update_budget_reappropriate_status
} from '../../helper/Api';
import { toast } from 'react-toastify';
import Spinner from '../Tools/spinner';
import DefaultFields from './components/DefaultFields';
import FromSchemeForm from './components/FromSchemeForm';
import FromSchemeList from './components/FromSchemeList';
import ToSchemeForm from './components/ToSchemeForm';
import ToSubheadsListComp from './components/ToSubheadListComp';
import CustomBreadcrumbs from '../Tools/Breadcumbs';
export default function AddBudgetReappropriate() {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const { authData, financialYears } = useSelector((state) => state.authData);
    const { id } = useParams();
    const [schemes, set_schemes] = useState([]);
    const [toSchemes, setToSchemes] = useState([]);
    const fy_list = financialYears.payload.fy_list;
    const [subheadsList, set_subheadsList] = useState([]);
    const [to_subheadsList, set_to_subheadsList] = useState([]);
    const [toSubheadsList, setToSubheadsList] = useState([]);
    const [fromSubheadsList, setFromSubheadsList] = useState([]);
    const [activity, setActivity] = useState([]);
    const [subActivity, setSubActivity] = useState([]);
    const totalAmount = useRef(0);
    const total1Amount = useRef(0);
    const totalFromAmount = useRef(0);
    const totalToAmount = useRef(0);
    const navigate = useNavigate();
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [department, setDepartment] = useState([]);
    const [formData, setFormData] = useState({
        id: '',
        reappropriate_order_no: '',
        reappropriate_order_date: '',
        reappropriate_order_value: '',
        attachment: [],
        department_id: authData.user.department_details.is_multi === "0" ? authData.user.department_details.id : "",
        department_name: "",
        department_type: authData.user.department_details.is_multi === "0" ? authData.user.department_details.type : "",
        financial_id: '',
        financial_year: '',
        to_subhead_list: [],
        created_by: authData && authData.status ? authData.user.id : null,
        order_url: ''
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [schemeLoading, setSchemeLoading] = useState(false);
    const [fromSchemeDetails, setFromSchemeDetails] = useState({
        scheme_id: '',
        scheme_name: '',
        department_name: '',
        grant_code: '',
        scheme_type: '',
        financial_id: '',
        financial_year: '',
        monitoring_level: '',
        is_activity_active: '',
        to_is_activity_active: '',
        to_monitoring_level: '',

        to_scheme_name: '',
        to_department_name: '',
        to_grant_code: '',
        to_scheme_type: '',
        to_subhead_name: '',
        to_subhead_balance: '',
    });
    const [toSubheadData, setToSubheadData] = useState({
        to_scheme_id: '',
        to_subhead_id: '',
        to_financial_id: '',
        to_reappropriation_amount: '',
        scheme_name: '',
        financial_year: '',
        subhead_name: '',
        subhead_balance: '',
        activity: [{
            activity_id: '',
            subactivity_id: '',
            provisional_budget: 0,
            budget: 0,
        }],
        activity_budget: [],
    })
    const [fromSubheadData, setFromSubheadData] = useState({
        from_scheme_id: '',
        from_subhead_id: '',
        from_financial_id: '',
        from_reappropriation_amount: '',
        scheme_name: '',
        financial_year: '',
        subhead_name: '',
        subhead_balance: '',
        activity: [{
            activity_id: '',
            subactivity_id: '',
            provisional_budget: 0,
            budget: 0,
        }],
        activity_budget: [],
    })
    const [screenType, setScreenType] = useState('');
    const [approveRequest,setApproveRequest]=useState({
        l2_approval: '',
        l3_approval: '',
    })
    const [approvalConfirm, setApprovalConfirm] = useState({
        open: false,
        status: null,
        actionLabel: '',
        userType: '',
        remarkValue: '',
    });
    // handle formal formdata
    const handleChallanFormData = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === 'department_id') {
                setFormData({
                ...formData,
                [name]: value,
                department_type: department.find(dept => dept.id == value)?.department_level || '',
            });
        } else {
            setFormData({
            ...formData,
            [name]: value
        });
        }
        if (name == 'from_scheme_id') {
            if (value) {
                const filter = schemes.find((scheme) => scheme.id == value);
                if (filter) {
                    const schemeList = schemes.filter(f => f.type == filter.type);
                    setToSchemes(schemeList);
                    setFromSchemeDetails(prevState => {
                        return {
                            ...prevState, scheme_name: filter.name,
                            department_name: filter.department,
                            grant_code: filter.grant_code,
                            scheme_type: filter.type,
                            is_activity_active: filter.is_activity_active,
                            monitoring_level: filter.monitoring_level,
                        }
                    })
                    set_subheadsList(filter.sub_head_list);
                    // clean to form data
                    setToSubheadData({
                        to_scheme_id: '',
                        to_subhead_id: '',
                        to_financial_id: '',
                        to_reappropriation_amount: '',
                        scheme_name: '',
                        financial_year: '',
                        subhead_name: '',
                        subhead_balance: '',
                    });
                    setToSubheadsList([]);
                    setFromSchemeDetails(prevState => {
                        return {
                            ...prevState, to_scheme_name: '',
                            to_department_name: '',
                            to_grant_code: '',
                            to_scheme_type: '',
                            to_subhead_name: '',
                            to_subhead_balance: '',
                        }
                    })
                    // clean to form data ends
                } else {
                    set_subheadsList([]);
                }
            } else {
                set_subheadsList([]);
            }
        }

        if (name == 'from_subhead_id') {
            if (value) {
                const subhead = subheadsList.find(e => e.id == value);
                if (subhead) {
                    if(fromSubheadsList.length > 0) {
                        const alreadySelected = fromSubheadsList.find(s => s.from_subhead_id == value);
                        if (alreadySelected) {
                            toast.error('This subhead is already selected', {
                                position: toast.POSITION.TOP_CENTER
                            });
                            return;
                        }
                    }
                    setFromSchemeDetails(prevState => {
                        return {
                            ...prevState,
                            subhead_name: subhead.name,
                            subhead_balance: subhead.balance,
                            subhead_budget: Number(subhead.budget),
                            subhead_provisional_budget: Number(subhead.provisional_budget),
                            activity_budget: subhead.activity_budget,
                        }
                    })
                    setFromSubheadData(prevState => {
                        return {
                            ...prevState,
                            subhead_name: subhead.name,
                            subhead_balance: subhead.balance - subhead.pervious_year_budget,
                            subhead_budget: Number(subhead.budget),
                            subhead_provisional_budget: Number(subhead.provisional_budget),
                            activity_budget: subhead.activity_budget,
                        }
                    })
                }
            }
        }
        if (name == 'from_reappropriation_amount') {
            if(value > fromSubheadData.subhead_balance) {
                toast.error('Reappropriation amount cannot be greater than subhead balance', {
                    position: toast.POSITION.TOP_CENTER
                });
                return;
            }
            setFromSubheadData({
                ...fromSubheadData,
                [name]: value
            });

        }
        if (name == 'to_reappropriation_amount') {
            setToSubheadData({
                ...toSubheadData,
                [name]: value
            });
        }
    }
    // handle from scheme details
    const handleSchemeChange = (event) => {
        const selectedSchemeId = event.target.value;
        if (selectedSchemeId && fromSchemeDetails.scheme_id) {
            setShowConfirm(true);
            return
        }
        // Find the scheme from the schemes list based on the selected scheme_id
        const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);

        if (selectedScheme) {
            const schemeList = schemes.filter(f => f.type == selectedScheme.type);
            setToSchemes(schemeList);
            // Set the state with the details of the selected scheme
            setFromSchemeDetails({
                ...fromSchemeDetails,
                scheme_id: selectedScheme.id,
                scheme_name: selectedScheme.name,
                department_name: selectedScheme.department,
                grant_code: selectedScheme.grant_code,
                scheme_type: selectedScheme.type,
                monitoring_level: selectedScheme.monitoring_level,
                is_activity_active: selectedScheme.is_activity_active,
            });
            set_subheadsList(selectedScheme.sub_head_list);
        }
        else {
            set_subheadsList([])
        }
    };

    //change financial year 
    const handleFinancialYearChange = async (event) => {
        const selectedYearId = event.target.value;
        const selectedYear = fy_list.find(fy => String(fy.id) === String(selectedYearId));
        const selectedYearName = selectedYear ? selectedYear.year : '';
        //  clear current subhead selection and details
        setFromSubheadData({
            from_scheme_id: '',
            from_subhead_id: '',
            from_financial_id: '',
            from_reappropriation_amount: '',
            scheme_name: '',
            financial_year: '',
            subhead_name: '',
            subhead_balance: '',
            activity: [{
                activity_id: '',
                subactivity_id: '',
                provisional_budget: 0,
                budget: 0,
            }],
            activity_budget: [],
        });
        
        await fetch_list(formData.department_id, selectedYearId);


        setFromSchemeDetails({
            ...fromSchemeDetails,
            financial_id: selectedYearId,
            financial_year: selectedYearName,
        });
        setFormData({
            ...formData,
            financial_id: selectedYearId,
            financial_year: selectedYearName,
        });
    };
    //change subhead  
    const handleSubheadChange = (event) => {
        const { value, name } = event.target;
        const selectedSubheadId = value;
        const alreadySelected = fromSubheadsList.find(subhead => subhead.from_subhead_id === selectedSubheadId && fromSchemeDetails.financial_id == subhead.from_financial_id);
        // if (fromSchemeDetails.is_activity_active == 0) {
            if (alreadySelected) {
                return alert('Subhead already selected');
            }
        // }
        const selectedSubhead = subheadsList.find(subhead => subhead.id === selectedSubheadId); // Find the subhead in the list
        if (selectedSubhead) {
            setFromSubheadData((prevState) => ({
                ...prevState,
                from_scheme_id: fromSchemeDetails.scheme_id,
                scheme_name: fromSchemeDetails.scheme_name,
                financial_year: fromSchemeDetails.financial_year,
                from_financial_id: fromSchemeDetails.financial_id,
                scheme_type: fromSchemeDetails.scheme_type,
                from_subhead_id: selectedSubhead.id,
                subhead_name: selectedSubhead.name,
                subhead_balance: selectedSubhead.balance - selectedSubhead.pervious_year_budget,
                activity_budget: selectedSubhead.activity_budget || [],
            }));
        }
    };
    //change subhead  
    const handleToSubheadChange = async (event) => {
        const { value, name } = event.target;
        if(name === 'to_financial_id') {
            setToSubheadData({
                to_scheme_id: '',
                to_subhead_id: '',
                to_financial_id: '',
                to_reappropriation_amount: '',
                scheme_name: '',
                financial_year: '',
                subhead_name: '',
                subhead_balance: '',
                activity: [{
                    activity_id: '',
                    subactivity_id: '',
                    provisional_budget: 0,
                    budget: 0,
                }],
                activity_budget: [],
            });
            totalToAmount.current = "";
            setToSubheadData((prevState) => ({
                ...prevState,
                to_financial_id: value,
            }));
            await fetch_list(formData.department_id, value);


        }
        if (name == 'to_scheme_id') {
            if (value) {
                const filter = schemes.find((scheme) => scheme.id == value);
                if (filter) {
                    setFromSchemeDetails(prevState => {
                        return {
                            ...prevState, to_scheme_name: filter.name,
                            to_department_name: filter.department,
                            to_grant_code: filter.grant_code,
                            to_scheme_type: filter.type,
                            to_is_activity_active: filter.is_activity_active,
                            to_monitoring_level: filter.monitoring_level,
                        }
                    })
                    setToSubheadData((prevState) => ({
                        ...prevState,
                        to_scheme_id: filter.id,
                        scheme_name: filter.name,
                        scheme_type: filter.type,
                        financial_year: filter.financial_year,
                    }));
                    set_to_subheadsList(filter.sub_head_list);
                } else {
                    set_to_subheadsList([]);
                }
            }
        }
        if (name == 'to_subhead_id') {
            const selectedSubheadId = value;
            const alreadySelected1 = toSubheadsList.find(subhead => subhead.to_subhead_id === selectedSubheadId);
            // const alreadySelected2 = fromSubheadsList.find(subhead => subhead.from_subhead_id === selectedSubheadId);
            if (fromSchemeDetails.is_activity_active == 0) {
                if (alreadySelected1 || selectedSubheadId == fromSubheadData.from_subhead_id) {
                    return alert('Subhead already selected');
                }
            }
            const selectedSubhead = to_subheadsList.find(subhead => subhead.id === selectedSubheadId); // Find the subhead in the list
            if (selectedSubhead) {
                setToSubheadData((prevState) => ({
                    ...prevState,
                    to_subhead_id: selectedSubhead.id,
                    subhead_name: selectedSubhead.name,
                    subhead_balance: selectedSubhead.balance,
                    activity_budget: selectedSubhead.activity_budget || [],
                }));
            }
        }
    };
    // from activity change
    const handleFromActivityChange = (activityIndex, e, activityId) => {
        const { name, value } = e.target;
        const activities = fromSubheadData.activity;  // Access the activity array from `fromSubheadData`

        // Check if the selected subactivity is already selected for the same activity_id
        if (activityId) {
            const activityValid = activities.find(
                (item) => item.subactivity_id === value && item.activity_id === activityId
            );
            if (activityValid) {
                return alert('Sub-activity already selected');
            }
        }

        // Handle budget change logic
        if (name === 'budget') {
            let totalBudget = 0;
            activities.map((item, index) => {
                const updatedBudget = index === activityIndex ? Number(value) : Number(item.budget);
                totalBudget += updatedBudget;
                return {
                    ...item,
                    budget: updatedBudget,
                };
            });

            let activityData = activities[activityIndex];
            if (activityData) {
                // If monitoring level is 2, validate against subhead_balance
                if (fromSchemeDetails.monitoring_level === "2") {
                    if (Number(fromSubheadData.subhead_balance) < Number(totalBudget)) {
                        return alert('Total available amount exceeds the amount.');
                    }
                } else {
                    // Validate the budget with activity_budget if available
                    if (fromSubheadData?.activity_budget) {
                        const subheadActivityData = fromSubheadData?.activity_budget.find(
                            (item) =>
                                item.subhead_activity_id === activityData.activity_id &&
                                item.subhead_subactivity_id === activityData.subactivity_id
                        );
                        if (subheadActivityData && Number(subheadActivityData.budget) < Number(value)) {
                            return alert('Total available amount exceeds the amount.');
                        }
                    }
                }
            }
            totalFromAmount.current = totalBudget;
            // // New: Check if total budget exceeds `totalFromAmount.current`
            // const totalAvailableAmount = Number(totalFromAmount?.current || 0);
            // if (totalBudget > totalAvailableAmount) {
            //     return alert('Total budget exceeds the available amount.');
            // }
        }

        setFromSubheadData((prevState) => {
            const updatedActivities = prevState.activity.map((activity, aIdx) => {
                if (aIdx === activityIndex) {
                    const updatedActivity = {
                        ...activity,
                        [name]: value,  // Update the field that triggered the change
                    };
                    // Reset subactivity_id if activity_id changes
                    if (name === 'activity_id') {
                        updatedActivity.subactivity_id = '';
                    }
                    return updatedActivity;
                }
                return activity;
            });

            return {
                ...prevState,
                activity: updatedActivities,  // Update the activity array
            };
        });
    };
    const handleToActivityChange = (activityIndex, e, activityId) => {
        const { name, value } = e.target;
        const activities = toSubheadData.activity;  // Access the activity array from `fromSubheadData`

        // Check if the selected subactivity is already selected for the same activity_id
        if (activityId) {
            const activityValid = activities.find(
                (item) => item.subactivity_id === value && item.activity_id === activityId
            );
            if (activityValid) {
                return alert('Sub-activity already selected');
            }
        }

        // Handle budget change logic
        if (name === 'budget') {
            let totalBudget = 0;
            const updatedActivities = activities.map((item, index) => {
                const updatedBudget = index === activityIndex ? Number(value) : Number(item.budget);
                totalBudget += updatedBudget;
                return {
                    ...item,
                    budget: updatedBudget,
                };
            });

            let activityData = activities[activityIndex];
            if (activityData) {
                // If monitoring level is 2, validate against subhead_balance
                if (fromSchemeDetails.monitoring_level === "2") {
                    // if (Number(toSubheadData.subhead_balance) < Number(totalBudget)) {
                    //     return alert('Total available amount exceeds the amount.');
                    // }
                } else {
                    // Validate the budget with activity_budget if available
                    // if (toSubheadData?.activity_budget) {
                    //     const subheadActivityData = toSubheadData?.activity_budget.find(
                    //         (item) =>
                    //             item.subhead_activity_id === activityData.activity_id &&
                    //             item.subhead_subactivity_id === activityData.subactivity_id
                    //     );
                    //     if (subheadActivityData && Number(subheadActivityData.budget) < Number(value)) {
                    //         return alert('Total available amount exceeds the amount.');
                    //     }
                    // }
                }
            }
            totalToAmount.current = totalBudget;
            // // New: Check if total budget exceeds `totalFromAmount.current`
            // const totalAvailableAmount = Number(totalFromAmount?.current || 0);
            // if (totalBudget > totalAvailableAmount) {
            //     return alert('Total budget exceeds the available amount.');
            // }
        }

        setToSubheadData((prevState) => {
            const updatedActivities = prevState.activity.map((activity, aIdx) => {
                if (aIdx === activityIndex) {
                    const updatedActivity = {
                        ...activity,
                        [name]: value,  // Update the field that triggered the change
                    };
                    // Reset subactivity_id if activity_id changes
                    if (name === 'activity_id') {
                        updatedActivity.subactivity_id = '';
                    }
                    return updatedActivity;
                }
                return activity;
            });

            return {
                ...prevState,
                activity: updatedActivities,  // Update the activity array
            };
        });
    };
    const handleFromSubheadSave = () => {
        if (
            fromSchemeDetails.is_activity_active == 0 || (fromSchemeDetails.monitoring_level == "2" && fromSchemeDetails.is_activity_active == 1) || (fromSchemeDetails.monitoring_level == "3" && fromSchemeDetails.is_activity_active == 1 && formData.department_type === 'T1')) {
            
            if(!fromSubheadData.from_reappropriation_amount) {
                toast.error('Please fill reappropriation amount', {
                    position: toast.POSITION.TOP_CENTER
                });
                return;
            }

            setFromSubheadsList(prevState => [
                ...prevState,
                {
                    ...fromSubheadData,
                }
            ]);
            totalAmount.current += Number(fromSubheadData.from_reappropriation_amount);
            setFromSubheadData({
                from_scheme_id: '',
                from_subhead_id: '',
                from_financial_id: '',
                from_reappropriation_amount: '',
                scheme_name: '',
                financial_year: '',
                subhead_name: '',
                subhead_balance: '',
                activity: [{
                    activity_id: '',
                    subactivity_id: '',
                    provisional_budget: 0,
                    budget: 0,
                }],
                activity_budget: [],
            });
            totalFromAmount.current = "";
        }
        else {
            let totalFrom = totalFromAmount.current;
            const isProvisionalBudgetZero = fromSubheadData.activity.some(activity => activity.budget === 0);
            if (
                !fromSubheadData.from_subhead_id ||
                !fromSubheadData.subhead_name ||
                !totalFromAmount.current
            ) {
                toast.error('Please fill all required fields', {
                    position: toast.POSITION.TOP_CENTER
                });
                return;
            }
            if (isProvisionalBudgetZero) {
                toast.error('Please fill all required fields (provisional budget cannot be zero)', {
                    position: toast.POSITION.TOP_CENTER
                });
                return; // Prevent further execution
            }
            setFromSubheadsList(prevState => [
                ...prevState,
                {
                    ...fromSubheadData,
                    from_reappropriation_amount: totalFrom
                }
            ]);
            totalAmount.current += Number(totalFrom);
            setFromSubheadData({
                from_scheme_id: '',
                from_subhead_id: '',
                from_financial_id: '',
                from_reappropriation_amount: '',
                scheme_name: '',
                financial_year: '',
                subhead_name: '',
                subhead_balance: '',
                activity: [{
                    activity_id: '',
                    subactivity_id: '',
                    provisional_budget: 0,
                    budget: 0,
                }],
                activity_budget: [],
            });
            totalFromAmount.current = "";
        }
    };
    const handleToSubheadSave = () => {
        if (
            fromSchemeDetails.is_activity_active == 0 || (fromSchemeDetails.monitoring_level == "2" && fromSchemeDetails.is_activity_active == 1) || (fromSchemeDetails.monitoring_level == "3" && fromSchemeDetails.is_activity_active == 1 && formData.department_type === 'T1')) {
            setToSubheadsList(prevState => [
                ...prevState,
                {
                    ...toSubheadData,
                }
            ]);
            total1Amount.current += Number(toSubheadData.to_reappropriation_amount);
            setToSubheadData({
                to_scheme_id: '',
                to_subhead_id: '',
                to_financial_id: '',
                to_reappropriation_amount: '',
                scheme_name: '',
                financial_year: '',
                subhead_name: '',
                subhead_balance: '',
                activity: [{
                    activity_id: '',
                    subactivity_id: '',
                    provisional_budget: 0,
                    budget: 0,
                }],
                activity_budget: [],
            });
            totalToAmount.current = "";
        }
        else {
            let totalTo = totalToAmount.current;
            const isProvisionalBudgetZero = toSubheadData.activity.some(activity => activity.budget === 0);
            if (
                !toSubheadData.to_subhead_id ||
                !toSubheadData.subhead_name ||
                !totalToAmount.current
            ) {
                toast.error('Please fill all required fields', {
                    position: toast.POSITION.TOP_CENTER
                });
                return;
            }
            if (isProvisionalBudgetZero) {
                toast.error('Please fill all required fields (provisional budget cannot be zero)', {
                    position: toast.POSITION.TOP_CENTER
                });
                return; // Prevent further execution
            }
            setFormData(prevState => {
                return {
                    ...prevState, to_subhead_list: [...formData.to_subhead_list, {
                        ...toSubheadData,
                        scheme_name: fromSchemeDetails.to_scheme_name,
                        subhead_name: fromSchemeDetails.to_subhead_name,
                        subhead_balance: fromSchemeDetails.to_subhead_balance
                    }]
                }
            });
            setToSubheadsList(prevState => [
                ...prevState,
                {
                    ...toSubheadData,
                    scheme_name: fromSchemeDetails.to_scheme_name,
                    to_reappropriation_amount: totalTo
                }
            ]);
            total1Amount.current += Number(totalTo);
            setToSubheadData({
                to_scheme_id: '',
                to_subhead_id: '',
                to_financial_id: '',
                to_reappropriation_amount: '',
                scheme_name: '',
                financial_year: '',
                subhead_name: '',
                subhead_balance: '',
                activity: [{
                    activity_id: '',
                    subactivity_id: '',
                    provisional_budget: 0,
                    budget: 0,
                }],
                activity_budget: [],
            });
            totalToAmount.current = "";
        }
    };
    const toggleNestedTable = (index) => {
        setExpandedIndex(prevIndex => (prevIndex === index ? null : index)); // If the same row is clicked, collapse it
    };
    const fetch_list = async (department_Id, financial_id) => {
        setLoading(true);
        setSchemeLoading(true);
        const schemes_list = await get_schemes({ department_id: department_Id, fy_id: financial_id });
        if (schemes_list.data.status) {
            if(fromSchemeDetails.scheme_id && subheadsList.length) {
                const schemeFromDetail = schemes_list.data.schemes.find(item => item.id === fromSchemeDetails.scheme_id);
                if(schemeFromDetail) {
                    set_subheadsList(schemeFromDetail.sub_head_list);
                } else {
                    set_subheadsList([]);
                }
            }
            if(toSubheadData.to_scheme_id && to_subheadsList.length) {
                const schemeToDetail = schemes_list.data.schemes.find(item => item.id === toSubheadData.to_scheme_id);
                if(schemeToDetail) {
                    set_to_subheadsList(schemeToDetail.sub_head_list);
                } else {
                    set_to_subheadsList([]);
                }
            }
            set_schemes(schemes_list.data.schemes);
            setSchemeLoading(false);
        } else {
            set_schemes([]);
        }
        if (id) {
            const budgetData = await get_single_budget_reappropriate(id);
            if (budgetData.data.result) {
                setApproveRequest({
                    l2_approval:budgetData.data.result.l2_approval,
                    l3_approval:budgetData.data.result.l3_approval,
                })
                setFormData((prevData) => ({
                    ...prevData,
                    reappropriate_order_no: budgetData.data.result.order_no,
                    reappropriate_order_date: budgetData.data.result.order_date,
                    reappropriate_order_value: budgetData.data.result.order_value,
                    department_id: budgetData.data.result.department_id,
                    order_url: budgetData.data.result.order_url,
                }));
                //total reapproprate value 
                const schemeFromDetail = schemes_list.data.schemes.find(item => item.id === budgetData.data.result.fromSubheads[0].from_scheme_id);
                const schemeToDetail = schemes_list.data.schemes.find(item => item.id === budgetData.data.result.toSubheads[0].to_scheme_id);
                set_subheadsList(schemeFromDetail.sub_head_list);
                set_to_subheadsList(schemeToDetail.sub_head_list);
                const schemeList = schemes.filter(f => f.type == schemeFromDetail.type);
                setToSchemes(schemeList);
                if (schemeFromDetail) {
                    setFromSchemeDetails(prevState => {
                        return {
                            ...prevState,
                            financial_id: budgetData.data.result?.fromSubheads[0]?.financial_year_id,
                            financial_year: schemeFromDetail?.financial_year,
                            scheme_id: schemeFromDetail?.id,
                            scheme_name: schemeFromDetail?.name,
                            department_name: schemeFromDetail?.department,
                            grant_code: schemeFromDetail?.grant_code,
                            scheme_type: schemeFromDetail?.type,
                            is_activity_active: schemeFromDetail?.is_activity_active,
                            monitoring_level: schemeFromDetail?.monitoring_level,

                            to_scheme_id: schemeToDetail?.id,
                            to_scheme_name: schemeToDetail?.name,
                            to_department_name: schemeToDetail?.department,
                            to_grant_code: schemeToDetail?.grant_code,
                            to_scheme_type: schemeToDetail?.type,
                            to_is_activity_active: schemeToDetail?.is_activity_active,
                            to_monitoring_level: schemeToDetail?.monitoring_level,
                        }
                    })
                    setToSubheadData({
                        to_scheme_id: schemeToDetail.id,
                        scheme_name: schemeToDetail.id,
                        financial_year: schemeToDetail?.financial_year,
                        subhead_balance: '',
                        activity: [{
                            activity_id: '',
                            subactivity_id: '',
                            provisional_budget: 0,
                            budget: 0,
                        }],
                        activity_budget: [],
                    })
                    const updatedFromSubheads = budgetData.data.result.fromSubheads.map(item => {
                        const subheadDetail = schemeFromDetail.sub_head_list.find(subhead => subhead.id === item.from_subhead_id);
                        const updatedActivities = item.activity.map(activityItem => ({
                            ...activityItem,
                            budget: Number(activityItem.amount)
                        }));
                        return {
                            ...item,
                            subhead_balance: subheadDetail?.budget,
                            activity_budget: subheadDetail?.activity_budget,
                            from_reappropriation_amount: item?.reappropriation_amount,
                            activity: updatedActivities
                        };
                    });
                    totalAmount.current = Number(updatedFromSubheads.reduce((total, item) => total + (item.reappropriation_amount || 0), 0))
                    setFromSubheadsList(updatedFromSubheads);
                }
                if (schemeToDetail) {
                    const updatedToSubheads = budgetData.data.result.toSubheads.map(item => {
                        const subheadDetail = schemeToDetail.sub_head_list.find(subhead => subhead.id === item.to_subhead_id);
                        const updatedActivities = item.activity.map(activityItem => ({
                            ...activityItem,
                            budget: Number(activityItem.amount)
                        }));
                        return {
                            ...item,
                            scheme_id: schemeToDetail?.id,
                            scheme_name: schemeToDetail?.name,
                            department_name: schemeToDetail?.department,
                            subhead_balance: subheadDetail?.budget,
                            activity_budget: subheadDetail?.activity_budget,
                            to_reappropriation_amount: item?.reappropriation_amount,
                            activity: updatedActivities,
                        };
                    });
                    total1Amount.current = updatedToSubheads.reduce((total, item) => total + Number(item?.reappropriation_amount), 0)
                    setToSubheadsList(updatedToSubheads);
                }
            }

        }
        setLoading(false);

    }
    const handleAttachmentChange = (event) => {
        const files = event.target.files;
        setFormData({
            ...formData,
            attachment: files
        });
    };

    // const previewHandler = (e) => {
    //     e.preventDefault();
    // };

    const handleSubmit = async (e) => {
        if (!id) {
            if (e && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }
        }
        try {
            if (toSubheadsList.length &&
                fromSubheadsList.length &&
                formData.reappropriate_order_no &&
                formData.reappropriate_order_date &&
                totalAmount.current &&
                fromSchemeDetails.scheme_id) {
                const post_data = new FormData();
                for (let i = 0; i < formData.attachment.length; i++) {
                    post_data.append('attachment[]', formData.attachment[i]);
                }
                post_data.append('from_scheme_id', fromSchemeDetails.scheme_id);
                post_data.append('reappropriate_order_no', formData.reappropriate_order_no);
                post_data.append('reappropriate_order_date', formData.reappropriate_order_date);
                post_data.append('reappropriate_order_value', totalAmount.current);
                post_data.append('from_subhead_list', JSON.stringify(fromSubheadsList));
                post_data.append('to_subhead_list', JSON.stringify(toSubheadsList));
                post_data.append('created_by', formData.created_by);
                post_data.append('department_id', formData.department_id);
                dispatch(ADD_CHALLAN_START());

                const response = await add_budget_reappropriate(post_data);
                let addDepositoryResponseData = response.data;
                if (addDepositoryResponseData.status) {
                    toSubheadsList.forEach(e => e.created_by = formData.created_by);
                    await add_budget_reappropriate_subhead({ subhead: toSubheadsList }, addDepositoryResponseData.result);
                    toast.success(
                        addDepositoryResponseData.message || 'Budget reappropriation created successfully.',
                        { position: toast.POSITION.TOP_CENTER }
                    );
                    navigate('/budget-reappropriate');

                } else {
                    throw new Error(
                        addDepositoryResponseData.message ||
                            "Could not create budget reappropriation."
                    );
                }
            } else {
                const missing = [];
                if (!fromSchemeDetails.scheme_id) {
                    missing.push("From scheme");
                }
                if (!fromSubheadsList.length) {
                    missing.push("at least one From subhead");
                }
                if (!toSubheadsList.length) {
                    missing.push("at least one To subhead");
                }
                if (!formData.reappropriate_order_no?.trim()) {
                    missing.push("Reappropriation order number");
                }
                if (!formData.reappropriate_order_date) {
                    missing.push("Reappropriation order date");
                }
                if (
                    totalAmount.current == null ||
                    totalAmount.current === "" ||
                    Number(totalAmount.current) <= 0
                ) {
                    missing.push("total reappropriation amount (must be greater than 0)");
                }
                const detail =
                    missing.length > 0
                        ? `Missing or invalid: ${missing.join("; ")}.`
                        : "Please complete all required fields before submitting.";
                throw new Error(detail);
            }
        } catch (error) {
            const data = error?.response?.data;
            const apiMessage =
                (typeof data === "string" && data) ||
                data?.message ||
                data?.error ||
                (Array.isArray(data?.errors) && data.errors.join(", ")) ||
                error?.message ||
                "Something went wrong while saving the reappropriation.";
            toast.error(apiMessage, {
                position: toast.POSITION.TOP_CENTER,
            });
            dispatch(ADD_CHALLAN_FAIL(apiMessage));
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get('screenType');
        setScreenType(type);
        fetchDepartments();
        if(id) {
            fetch_list();
        }
        fetchActivity();
        fetchSubActivity();
    }, [])
    const removeSubhead = (index, listType = 'to') => {
        const targetList = listType === 'to' ? toSubheadsList : fromSubheadsList;
        const updatedSubHeads = targetList.filter((_, i) => i !== index);
        totalAmount.current = 0;
        updatedSubHeads.forEach(e => {
            if (listType === 'to') {
                totalAmount.current += Number(e.to_reappropriation_amount);
            } else {
                totalAmount.current += Number(e.from_reappropriation_amount);
            }
        });
        if (listType === 'to') {
            total1Amount.current = 0;
            setToSubheadsList(updatedSubHeads);
        } else {
            totalAmount.current = 0;
            setFromSubheadsList(updatedSubHeads);
        }
    };
    const fetchActivity = async () => {
        try {
            const resp = await getActivity();
            if (resp.data.status) {
                setActivity(resp.data.result);
            }
        } catch (error) {
            setActivity([]);
        }
    }
    const fetchSubActivity = async () => {
        try {
            const resp = await getSubActivity();
            if (resp.data.status) {
                setSubActivity(resp.data.result);
            }
        } catch (error) {
            setSubActivity([]);
        }
    }
    const findSubActivitiesById = (id) => {
        let listData = subActivity;
        return listData.filter(subActivity => subActivity.activity_id === id);
    };
    // const handleSubheadBudgetFormData = (activityIndex, e) => {
    //     const { name, value } = e.target;
    //     let totalProvisionalBudget = 0;
    //     let totalBudget = 0;
    //     fromSchemeDetails.activity.forEach((item, activityI) => {
    //         if (activityI !== activityIndex) {
    //             totalProvisionalBudget += parseFloat(item.provisional_budget || 0);
    //             totalBudget += parseFloat(item.budget || 0);
    //         }
    //     });
    //     if (name === 'provisional_budget') {
    //         totalProvisionalBudget = Number(totalProvisionalBudget) + Number(value);
    //         if (totalProvisionalBudget > Number(fromSchemeDetails.subhead_provisional_budget)) {
    //             fromSchemeDetails.activity[activityIndex]['provisional_budget'] = 0;
    //             return alert('Total provisional budget exceeds the allowed amount=' + fromSchemeDetails.subhead_provisional_budget);
    //         }
    //     }
    //     if (name === 'budget') {
    //         totalBudget = totalBudget + Number(value);
    //         if (totalBudget > Number(fromSchemeDetails.subhead_budget)) {
    //             fromSchemeDetails.activity[activityIndex]['budget'] = 0;
    //             return alert('Total budget exceeds the allowed amount=' + fromSchemeDetails.subhead_budget);
    //         }
    //     }
    //     setFromSchemeDetails(prevDetails => {
    //         const updatedActivities = prevDetails.activity.map((activity, aIdx) => {
    //             if (aIdx === activityIndex) {
    //                 const updatedActivity = {
    //                     ...activity,
    //                     [name]: value
    //                 };
    //                 if (name === 'activity_id') {
    //                     updatedActivity.subactivity_id = '';
    //                 }

    //                 return updatedActivity;
    //             }
    //             return activity;
    //         });
    //         return {
    //             ...prevDetails,
    //             activity: updatedActivities
    //         };
    //     });
    // };
    // const handleToSubheadBudgetFormData = (activityIndex, e) => {
    //     const { name, value } = e.target;
    //     let totalProvisionalBudget = 0;
    //     let totalBudget = 0;
    //     fromSchemeDetails.to_activity.forEach((item, activityI) => {
    //         if (activityI !== activityIndex) {
    //             totalProvisionalBudget += parseFloat(item.provisional_budget || 0);
    //             totalBudget += parseFloat(item.budget || 0);
    //         }
    //     });
    //     if (name === 'provisional_budget') {
    //         totalProvisionalBudget = Number(totalProvisionalBudget) + Number(value);
    //         if (totalProvisionalBudget > Number(fromSchemeDetails.to_subhead_provisional_budget)) {
    //             fromSchemeDetails.activity[activityIndex]['provisional_budget'] = 0;
    //             return alert('Total provisional budget exceeds the allowed amount=' + fromSchemeDetails.to_subhead_provisional_budget);
    //         }
    //     }
    //     if (name === 'budget') {
    //         totalBudget = totalBudget + Number(value);
    //         if (totalBudget > Number(fromSchemeDetails.to_subhead_budget)) {
    //             fromSchemeDetails.activity[activityIndex]['budget'] = 0;
    //             return alert('Total budget exceeds the allowed amount=' + fromSchemeDetails.to_subhead_budget);
    //         }
    //     }
    //     setFromSchemeDetails(prevDetails => {
    //         const updatedActivities = prevDetails.to_activity.map((activity, aIdx) => {
    //             if (aIdx === activityIndex) {
    //                 const updatedActivity = {
    //                     ...activity,
    //                     [name]: value
    //                 };
    //                 if (name === 'activity_id') {
    //                     updatedActivity.subactivity_id = '';
    //                 }

    //                 return updatedActivity;
    //             }
    //             return activity;
    //         });
    //         return {
    //             ...prevDetails,
    //             to_activity: updatedActivities
    //         };
    //     });
    // };
    const addNewActivity = (type) => {
        const newActivity = { activity_id: '', subactivity_id: '', provisional_budget: 0, budget: 0 };
        if (type == 'from') {
            setFromSubheadData(prevDetails => {
                return {
                    ...prevDetails,
                    activity: [...prevDetails.activity, newActivity]
                };
            });
        }
        else {
            setToSubheadData(prevDetails => {
                return {
                    ...prevDetails,
                    activity: [...prevDetails.activity, newActivity]
                };
            });
        }
    };
    const deleteNewActivity = (activityIndex, type) => {
        if (type == 'from') {
            if (fromSubheadData.activity.length > 1) {
                setFromSubheadData(prevDetails => {
                    const updatedActivities = [...prevDetails.activity];
                    updatedActivities.splice(activityIndex, 1);  // Remove activity at the specified index
                    return {
                        ...prevDetails,
                        activity: updatedActivities
                    };
                });
            }
        }
        else {
            if (toSubheadData.activity.length > 1) {
                setToSubheadData(prevDetails => {
                    const updatedActivities = [...prevDetails.activity];
                    updatedActivities.splice(activityIndex, 1);  // Remove activity at the specified index
                    return {
                        ...prevDetails,
                        activity: updatedActivities
                    };
                });
            }
        }
    };
    const fetchDepartments = async (scheme_id = null) => {
        try {
            const departments = await get_departments({ parent_department_id: authData.user.department_details.id });
            if (departments.data.status) {
                if(authData.user.department_details.department_level == 'T1') {
                    setDepartment(departments.data.result);
                } else {
                    const filteredDepartments = departments.data.result.filter(dept => dept.id !== authData.user.department_details.id);
                    setDepartment(filteredDepartments);
                }
                
            }
        } catch (error) {
            toast.error('Error fetching departments', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }
    const handleConfirm = (value) => {
        setShowConfirm(value)
    }
    const confirmSubmit = () => {
        setShowConfirm(false)
        setFromSchemeDetails({
            scheme_id: '',
            scheme_name: '',
            department_name: '',
            grant_code: '',
            scheme_type: '',
            financial_id: '',
            financial_year: '',
            monitoring_level: '',
            is_activity_active: '',
        });
        setFromSubheadData({
            from_scheme_id: '',
            from_subhead_id: '',
            from_financial_id: '',
            from_reappropriation_amount: '',
            scheme_name: '',
            financial_year: '',
            subhead_name: '',
            subhead_balance: '',
            activity: [{
                activity_id: '',
                subactivity_id: '',
                provisional_budget: 0,
                budget: 0,
            }],
            activity_budget: []
        })
        setToSubheadData({
            to_scheme_id: '',
            to_subhead_id: '',
            to_financial_id: '',
            to_reappropriation_amount: '',
            scheme_name: '',
            financial_year: '',
            subhead_name: '',
            subhead_balance: '',
            activity: [{
                activity_id: '',
                subactivity_id: '',
                provisional_budget: 0,
                budget: 0,
            }],
            activity_budget: [],
        })
        setFromSubheadsList([])
        setToSubheadsList([])
        totalFromAmount.current = null;
        totalAmount.current = null;
    }
    const heading = () => {
        if (screenType === 'View') {
            return 'View Budget Reappropriate';
        } else if (screenType === 'Edit') {
            return 'Edit Budget Reappropriate';
        } else {
            return 'Add Budget Reappropriate';
        }
    }
    const handleApprove = async (status) => {
        const userType = String(authData?.user?.user_type || '').toLowerCase();
        if (userType !== 'l2' && userType !== 'l3') {
            toast.error('You are not allowed to perform this action.', { position: toast.POSITION.TOP_CENTER });
            return;
        }
        if (!id) {
            toast.error('Missing request id.', { position: toast.POSITION.TOP_CENTER });
            return;
        }

        const isApprove = String(status) === '1';
        const actionLabel = isApprove ? 'approve' : 'reject';

        const remarkValue =
            userType === 'l2'
                ? (formData?.l2_remarks || '').trim()
                : (formData?.l3_remarks || '').trim();

        if (!remarkValue) {
            toast.error(`Please enter ${userType.toUpperCase()} remark before you ${actionLabel}.`, {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        setApprovalConfirm({
            open: true,
            status: String(status),
            actionLabel,
            userType,
            remarkValue,
        });
    };

    const closeApprovalConfirm = () => {
        setApprovalConfirm({
            open: false,
            status: null,
            actionLabel: '',
            userType: '',
            remarkValue: '',
        });
    };

    const confirmApprovalAction = async () => {
        if (!approvalConfirm?.status || !id) return;
        const isApprove = approvalConfirm.status === '1';
        try {
            setLoading(true);
            const payload =
                approvalConfirm.userType === 'l2'
                    ? { l2_status: approvalConfirm.status, l2_remark: approvalConfirm.remarkValue }
                    : { l3_status: approvalConfirm.status, l3_remark: approvalConfirm.remarkValue };

            const res = await update_budget_reappropriate_status(payload, id);
            if (res?.data?.status) {
                toast.success(res.data.message || `Request ${isApprove ? 'approved' : 'rejected'} successfully.`, {
                    position: toast.POSITION.TOP_CENTER,
                });

                setApproveRequest((prev) => ({
                    ...prev,
                    l2_approval: approvalConfirm.userType === 'l2' ? approvalConfirm.status : prev.l2_approval,
                    l3_approval: approvalConfirm.userType === 'l3' ? approvalConfirm.status : prev.l3_approval,
                }));

                closeApprovalConfirm();
                navigate('/budget-reappropriate');
            } else {
                toast.error(res?.data?.message || 'Request failed.', { position: toast.POSITION.TOP_CENTER });
            }
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.message ||
                'Something went wrong.';
            toast.error(msg, { position: toast.POSITION.TOP_CENTER });
        } finally {
            setLoading(false);
        }
    };

    const linksArray = [
        {
            href: "/budget-reappropriate",
            label: "Budget Reappropriation",
        }
    ];
    return (
        <>
            <div>
                {loading && <div > <Spinner/> </div>}
                <div className="p-3">
                    <div className="row" style={{padding: "8px 10px"}}>
                        <div className="col-md-6">
                            <h4 style={{ color: "#28326f", margin: 0 }}>{heading()}</h4>
                            <CustomBreadcrumbs linksArray={linksArray} title={heading()} />
                        </div>
                        <div className="col-md-6">
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card p-3 mt-3">
                                <div className="row">
                                    <DefaultFields 
                                    formData={formData} 
                                    handleChallanFormData={handleChallanFormData}
                                    handleAttachmentChange={handleAttachmentChange} 
                                    schemeLoading={schemeLoading}
                                    department={department}
                                    screenType={screenType}
                                    totalAmount={totalAmount}

                                    />
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                    {
                                        screenType !== 'View' && <FromSchemeForm 
                                        handleChallanFormData={handleChallanFormData}
                                        schemeLoading={schemeLoading}
                                        screenType={screenType}
                                        handleFinancialYearChange={handleFinancialYearChange}
                                        fromSchemeDetails={fromSchemeDetails}
                                        subheadsList={subheadsList}
                                        fromSubheadData={fromSubheadData}
                                        handleSubheadChange={handleSubheadChange}
                                        handleFromActivityChange={handleFromActivityChange}
                                        handleFromSubheadSave={handleFromSubheadSave}
                                        addNewActivity={addNewActivity}
                                        deleteNewActivity={deleteNewActivity}
                                        fy_list={fy_list}
                                        schemes={schemes}
                                        handleSchemeChange={handleSchemeChange}
                                        totalFromAmount={totalFromAmount}
                                        activity={activity}
                                        findSubActivitiesById={findSubActivitiesById}
                                        formData={formData}
                                    />
                                    }
                                    
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                    <FromSchemeList 
                                        fromSchemeDetails={fromSchemeDetails}
                                        fromSubheadsList={fromSubheadsList}
                                        screenType={screenType}
                                        toggleNestedTable={toggleNestedTable}
                                        removeSubhead={removeSubhead}
                                        activity={activity}
                                        findSubActivitiesById={findSubActivitiesById}
                                        fy_list={fy_list}
                                        expandedIndex={expandedIndex}
                                        totalAmount={totalAmount}
                                    />
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                    {
                                        screenType !== 'View' && <ToSchemeForm 
                                        handleChallanFormData={handleChallanFormData}
                                        schemeLoading={schemeLoading}
                                        screenType={screenType}
                                        handleFinancialYearChange={handleFinancialYearChange}
                                        fromSchemeDetails={fromSchemeDetails}
                                        toSubheadData={toSubheadData}
                                        handleToSubheadChange={handleToSubheadChange}
                                        handleToActivityChange={handleToActivityChange}
                                        fy_list={fy_list}
                                        toSchemes={toSchemes}
                                        totalToAmount={totalToAmount}
                                        activity={activity}
                                        findSubActivitiesById={findSubActivitiesById}
                                        to_subheadsList={to_subheadsList}
                                        addNewActivity={addNewActivity}
                                        deleteNewActivity={deleteNewActivity}
                                        fromSubheadsList={fromSubheadsList}
                                        formData={formData}

                                    />
                                    }
                                    
                                    
                                    {/*  disabled={activeAddToSubhead.current} */}
                                    {screenType != 'View' && <div className='col-md-12'><button type="button" onClick={handleToSubheadSave} className='navigation_button mt-2'>Add Subhead</button></div>}
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                    <ToSubheadsListComp
                                        toSubheadsList={toSubheadsList}
                                        fy_list={fy_list}
                                        fromSchemeDetails={fromSchemeDetails}
                                        screenType={screenType}
                                        total1Amount={total1Amount}
                                        removeSubhead={removeSubhead}
                                        handleSubmit={handleSubmit}
                                        activity={activity}
                                        findSubActivitiesById={findSubActivitiesById}
                                        expandedIndex={expandedIndex}
                                        toggleNestedTable={toggleNestedTable}
                                    />
                                </div>
                                {screenType=='View' && <><div class="row mt-3">
                                    <div class="col">
                                        <div class="form-group d-flex align-items-center">
                                            <label for="input2" class="mr-2">L2 Remarks</label>
                                            <textarea id="l2_remarks" className="form-control" rows="2" name="l2_remarks" readOnly={authData.user.user_type !== 'l2' || !!approveRequest.l2_approval} onChange={handleChallanFormData} value={formData.l2_remarks}></textarea>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group d-flex align-items-center">
                                            <label for="input3" class="mr-2">L3 Remarks</label>
                                            <textarea id="l3_remarks" className="form-control" rows="2" name="l3_remarks" readOnly={authData.user.user_type !== 'l3' || !!approveRequest.l3_approval} onChange={handleChallanFormData} value={formData.l3_remarks}></textarea>
                                        </div>
                                    </div>
                                </div>
                                {(authData.user.user_type == 'l2' && !approveRequest.l2_approval) || (authData.user.user_type == 'l3' && !approveRequest.l3_approval) ? (
                                    <div className="d-flex justify-content-center gap-2 mt-2 flex-wrap w-100">
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            style={{ minWidth: 140, height: 38, fontWeight: 600 }}
                                            onClick={() => handleApprove(1)}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            style={{ minWidth: 140, height: 38, fontWeight: 600 }}
                                            onClick={() => handleApprove(0)}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                ) : (
                                    ''
                                )
                                }</>}
                            </div>
                        </div>
                        {/* </Form> */}
                    </div>
                </div>
            </div>
            <Modal show={showConfirm} onHide={() => handleConfirm(false)} centered>
                <Modal.Header closeButton={() => handleConfirm(false)}>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>If you want to change the scheme, you will lose any filled data. Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => confirmSubmit()}>
                        YES
                    </Button>
                    <Button variant="danger" onClick={() => handleConfirm(false)}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={approvalConfirm.open} onHide={closeApprovalConfirm} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-0">
                        Are you sure you want to <strong>{approvalConfirm.actionLabel}</strong> this
                        budget reappropriation request?
                    </p>
                    <p className="mt-2 mb-0 text-muted small">
                        This will be recorded as a {approvalConfirm.userType?.toUpperCase()} decision.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeApprovalConfirm}>
                        Cancel
                    </Button>
                    <Button
                        variant={approvalConfirm.status === '1' ? 'success' : 'danger'}
                        onClick={confirmApprovalAction}
                    >
                        Yes, {approvalConfirm.actionLabel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}